import { guestProfie } from "./commonUtils";
import { getAppState } from "../state/index";

export function getGuestUserID() {
  const gProfie = guestProfie();
  return gProfie?.globalUserId;
}

export function isGuestUserLoggedIn() {
  return getAppState().isGuestProfile;
}
